exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2l_V9pQcgSeXzj-zX4nUYI{padding:0 40px;background:#ebeed7;color:#212121}._2l_V9pQcgSeXzj-zX4nUYI a._2tmfcTrmYN1BOFJKWobUvt{color:#fa6400}\n", ""]);

// Exports
exports.locals = {
	"TrialNoticeBar": "_2l_V9pQcgSeXzj-zX4nUYI",
	"orange": "_2tmfcTrmYN1BOFJKWobUvt"
};